import React, { Component, Fragment } from 'react';

import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import styled from 'styled-components';

import { drawerStyles } from 'helpers/StyleHelper';

import LeaseDetailsForm from './LeaseDetailsForm';
import LeaseOptions from './LeaseOptions';
import YardiLeaseOptions from './YardiLeaseOptions';

import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import FooterButtons from 'components/shared/FooterButtons';
import { RentRollStatus } from 'components/shared/StatusHelper';
import TabbedPanel from 'components/shared/TabbedPanel';

import TenantsForm from './TenantsForm';
import RenewalStepper from './RenewalStepper';
import RenewalStatusDetails from './RenewalStatusDetails';

import Paper from '@material-ui/core/Paper';

import { deepDiver } from 'helpers/utilities';
import { formatPhone } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

import { CotenantStatus } from 'components/shared/StatusHelper';
import { RenderIfToggleOff } from 'components/shared/ToggleRenderer';
import { featureEnabled } from 'helpers/ToggleBot';

let styles = {
  avatarStyle: {
    height: '120px',
    width: '120px',
    border: '0px solid #e1e1e1',
    backgroundSize: 'cover',
    float: 'right',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 0',
  },
  transaction_card: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
  },
};

const StyledWarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  padding: 14px 0 28px;
`;

const StyledWarningImg = styled.img`
  display: block;
  margin-bottom: 8px;
`;
export default class LeaseOverview extends Component {
  toggleEditTenantDialog = () => {
    this.setState(prevState => ({
      tenantDialogOpen: !prevState.tenantDialogOpen,
    }));
  };

  toggleConfirmationDialog = () => {
    this.setState({
      showConfirmationDialog: !this.state.showConfirmationDialog,
    });
  };

  togglePapConfirmationDialog = () => {
    this.setState({
      showPapConfirmationDialog: !this.state.showPapConfirmationDialog,
    });
  };

  render() {
    const yardiBased =
      !!this.props.leaseDetails.property && !!this.props.leaseDetails.property.yardi_based;
    //  property id check here is temporary for FourStar
    const yardiRenewalInProgress =
      yardiBased &&
      featureEnabled('yardi_renewals') &&
      (window.ENV !== 'production' || [492, 490, 491].includes(this.props.leaseDetails.property_id)) &&
      this.props.leaseDetails.is_renewing;

    const tabHeaders = [
      'Details',
      <span>
        <TenantResidentVerbiageHelper capitalize />s
      </span>,
      'Options',
    ];
    const tabBodies = [
      this._renderDetailsBody(),
      this._renderTenantsBody(),
      this._renderOptionsBody(yardiRenewalInProgress),
    ];
    const tabFooters = [
      this._renderSaveLeaseFooter('lease_details'),
      this._renderSaveLeaseFooter('residents'),
      this._renderCloseOnlyFooter(),
    ];

    if (this.props.leaseDetails.is_renewing) {
      tabHeaders.unshift('Status');
      tabBodies.unshift(this._renderRenewalDetails());
      tabFooters.unshift(this._renderCloseOnlyFooter());
    }

    return (
      <Fragment>
        <div className="row" style={drawerStyles.tabbedHeaderWrapper}>
          <h3 style={{ textAlign: 'center', margin: '8px 0' }}>
            Unit {this.props.leaseDetails.unit} &nbsp;
            <span>
              {
                <RentRollStatus
                  style={{
                    fontSize: '41%',
                    top: '4px',
                    padding: '5px 5px 5px',
                  }}
                  leaseDetails={this.props.leaseDetails}
                />
              }
            </span>
          </h3>
        </div>

        <TabbedPanel tabHeaders={tabHeaders} tabBodies={tabBodies} tabFooters={tabFooters} />
      </Fragment>
    );
  }

  _renderDetailsBody = () => (
    <div style={drawerStyles.tabBodyWrapper}>
      {/************ Lease Details **************/}
      {!this.props.leaseDetails.editable && (
        <p style={{ textAlign: 'justify' }}>
          <i className="em em-warning" />
          <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>
            {' '}
            {getTranslatedString('landlordPortal.rentRoll.important')}
          </b>
          <i className="em em-warning" />{' '}
          {getTranslatedString('landlordPortal.rentRoll.warningExternalLease')}
        </p>
      )}

      <RenderIfToggleOff toggle="ui.rent_roll_page.edit_lease_detail">
        <StyledWarningContainer>
          <StyledWarningImg src="/alert.svg" alt="alert" height={30} />
          <p>{getTranslatedString('landlordPortal.rentRoll.readOnlyLease')}</p>
        </StyledWarningContainer>
      </RenderIfToggleOff>

      <Card style={styles.transaction_card}>
        <CardText expandable={true} style={{ padding: '0 0 10px' }}>
          <LeaseDetailsForm
            form={'lease_details'}
            initialValues={this.props.leaseDetails}
            onSubmit={formData => this.props.updateLeaseDetails(formData)}
          />
        </CardText>
      </Card>
    </div>
  );

  _renderTenantsBody = () => (
    <div style={drawerStyles.tabBodyWrapper}>
      {!this.props.leaseDetails.editable && (
        <p style={{ textAlign: 'justify' }}>
          <i className="em em-warning" />
          <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>
            {getTranslatedString('landlordPortal.rentRoll.important')}
          </b>
          <i className="em em-warning" />
          {getTranslatedString('landlordPortal.rentRoll.warningExternalLease')}
        </p>
      )}
      {/************ Tenants **************/}
      <TenantsForm
        formName={'residents'}
        leaseDetails={this.props.leaseDetails}
        getRentRollData={this.props.fetchRentRollAndStats}
        getLeaseData={this.props.openEditLease}
        onSubmit={formData => this.props.updateLeaseDetails(formData)}
      />
    </div>
  );

  _renderOptionsBody = yardiRenewalInProgress => (
    <div style={drawerStyles.tabBodyWrapper}>
      {!this.props.leaseDetails.editable && (
        <p style={{ textAlign: 'justify' }}>
          <i className="em em-warning" />
          <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>
            {getTranslatedString('landlordPortal.rentRoll.important')}
          </b>
          <i className="em em-warning" />
          {getTranslatedString('landlordPortal.rentRoll.warningExternalLease')}
        </p>
      )}
      {yardiRenewalInProgress ? (
        <YardiLeaseOptions
          leaseDetails={this.props.leaseDetails}
          fetchRentRoll={this.props.fetchRentRoll}
          toggleDrawer={this.props.toggleDrawer}
        />
      ) : (
        <LeaseOptions
          leaseDetails={this.props.leaseDetails}
          getRentRollData={this.props.fetchRentRollAndStats}
          toggleDrawer={this.props.toggleDrawer}
        />
      )}
    </div>
  );

  _renderSaveLeaseFooter = formName => (
    <FooterButtons
      backName={getTranslatedString('landlordPortal.leaseOverview.close')}
      formName={formName}
      submitName={getTranslatedString('landlordPortal.leaseOverview.save')}
      backAction={this.props.toggleDrawer}
    />
  );

  _renderCloseOnlyFooter = () => (
    <FooterButtons
      hideSubmitButton
      backName={getTranslatedString('landlordPortal.rentRoll.close')}
      backAction={this.props.toggleDrawer}
    />
  );

  _renderRenewalDetails = () => (
    <Fragment>
      {/* property id check here is temporary for FourStar */}
      {featureEnabled('yardi_renewals') &&
      (window.ENV !== 'production' || [492, 490, 491].includes(this.props.leaseDetails.property_id)) ? (
        <RenewalStatusDetails
          cotenants={this.props.leaseDetails.cotenants}
          toggleDrawer={this.props.toggleDrawer}
          toggleInPersonDocumentSigning={this.props.toggleInPersonDocumentSigning}
        />
      ) : (
        <div style={{ padding: 15 }}>
          <RenewalStepper toggleDrawer={this.props.toggleDrawer} />
          <h3>
            <TenantResidentVerbiageHelper capitalize />{' '}
            {getTranslatedString('landlordPortal.rentRoll.details')}
          </h3>
          {this._renderRenewalCotenants()}
        </div>
      )}
    </Fragment>
  );

  _renderRenewalCotenants = () => {
    const cotenants = deepDiver(this.props.leaseDetails, 'cotenants');
    return cotenants.map(cotenant => {
      const cotenantDetails = cotenant.general_details;
      styles = {
        ...styles,
        avatarStyle: {
          ...styles.avatarStyle,
          backgroundImage: 'url(' + deepDiver(cotenantDetails, 'avatar_url') + ')',
        },
      };

      return (
        <React.Fragment>
          <Card style={{ ...styles.transaction_card, marginBottom: '25px' }}>
            <CardText expandable style={{ padding: '0' }}>
              <div className="row" style={{ margin: '15px 0 15px' }}>
                <div className="col-xs-9">
                  <div className="row" style={{ margin: '10px 0' }}>
                    <div className="col-xs-10" style={{ padding: 0 }}>
                      <CotenantStatus status={cotenant.renewal_status} />
                    </div>
                  </div>
                  <h4 style={{ marginTop: 0, fontFamily: 'Circular-Bold' }}>
                    {cotenantDetails.full_name}
                  </h4>
                  <h5 style={{ marginTop: 0, overflowWrap: 'break-word' }}>
                    {cotenantDetails.email}
                  </h5>
                  <h5 style={{ marginTop: 0 }}>{formatPhone(cotenantDetails.phone_number)}</h5>
                </div>
                <div className="col-xs-3">
                  <Paper circle={true} style={styles.avatarStyle} />
                </div>
              </div>
            </CardText>
          </Card>
        </React.Fragment>
      );
    });
  };
}
